module.exports = function () {

    let module = {};

    module.environment = process.env.NODE_ENV;
    module.isLive = (module.environment == 'production') ? true : false;
    module.isStaging = (module.environment == 'staging') ? true : false;
    module.isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) ? true : false;


    module.log = function (message) {
        if (!module.isStaging && !module.isLive)
            return console.log(message);
    };

    // Only include Bootstrap modules required
    module.initBootstrap = function () {
        require('bootstrap/js/dist/index');
        require('bootstrap/js/dist/alert');
        require('bootstrap/js/dist/button'); // required for auto complete library
        //require('bootstrap/js/dist/carousel');
        require('bootstrap/js/dist/collapse');
        require('bootstrap/js/dist/dropdown');
        require('bootstrap/js/dist/modal');
        // require('bootstrap/js/dist/popover');
        // require('bootstrap/js/dist/scrollspy');
        // require('bootstrap/js/dist/tab');
        // require('bootstrap/js/dist/tooltip');
        // require('bootstrap/js/dist/util');
    };

    // module.initDatepicker = function () {
    //     require('jquery-ui/ui/keycode');
    //     require('jquery-ui/ui/widgets/datepicker');
    //
    //     $('.datepicker').datepicker({
    //         dateFormat: "d MM yy",
    //         changeMonth: true,
    //         changeYear: true,
    //         maxDate: "-18y"
    //     });
    // }


    // Background videos wait for the page load so they don't compete with the hero image.
    // Skipped for reduced motion and data saver users, who keep the still image.
    module.initDeferredVideos = function () {
        let videos = document.querySelectorAll('video.hero-video[data-src]');
        if (!videos.length) return;

        let reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        let saveData = navigator.connection && navigator.connection.saveData;
        if (reduceMotion || saveData) return;

        let loadVideos = function () {
            videos.forEach(function (video) {
                if (video.closest('.slick-cloned')) return;

                video.addEventListener('playing', function () {
                    video.classList.add('is-playing');
                }, {once: true});

                video.src = video.getAttribute('data-src');
                video.removeAttribute('data-src');
                video.play().catch(function () { /* autoplay blocked, the still image stays */ });
            });
        };

        if (document.readyState === 'complete') loadVideos();
        else window.addEventListener('load', loadVideos, {once: true});
    };

    module.initRrssb = function () {
        require('rrssb');
    };

    module.initPopups = function () {
        if ($('#popupModal').length) {
            let id = $('#popupModal').data('id');
            let popupShown = localStorage.getItem('popup-' + id + '-shown');
            let expirationDate = localStorage.getItem('popup-' + id + '-expiration');

            // Check if the popup has been shown and if the expiration date has passed
            if (!popupShown || Date.now() > parseInt(expirationDate)) {
                let delay = parseInt($('#popupModal').data('delay') + '000');
                let next_display_time = parseInt($('#popupModal').data('next-display-time'));
                const expirationTime = Date.now() + (next_display_time ? next_display_time : 7) * 24 * 60 * 60 * 1000; // Current time + 7 days in milliseconds

                setTimeout(function () {
                    $('#popupModal').modal('show');
                    localStorage.setItem('popup-' + id + '-shown', 'true');
                    localStorage.setItem('popup-' + id + '-expiration', expirationTime.toString());
                }, delay ? delay : 2000);
            }
        }
    };

    module.keepTokenAlive = function (){

        // To override the default mins, add a <body> data tag value for 'token_minutes'
        let keepAlive = $('body').data('token-minutes');

        setInterval(keepTokenAlive, 1000 * 60 * (keepAlive ? keepAlive : 3)); // every 3 or x mins

        function keepTokenAlive() {
            $.ajax({
                url: '/keep-token-alive', //https://stackoverflow.com/q/31449434/470749
                method: 'post',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            }).then(function (result) {
                console.log(new Date() + ' ' + result + ' ' + $('meta[name="csrf-token"]').attr('content'));
            });
        }
    }

    module.initTooltips = function () {

        $('[data-toggle="tooltip"]').tooltip({
            trigger: 'hover focus',
            placement: 'bottom',
            container: 'body'
        });
    };


    module.initStickyEl = function () {

        // Get sticky el's
        let el = $('.is-sticky');

        sessionStorage.setItem('height', $('header').height());

        // When the user scrolls the page, execute myFunction
        window.onscroll = function () {
            module.addStickyClass();
        };

        module.addStickyClass();
    };

    module.addStickyClass = function () {

        let body = $('body');

        let height = sessionStorage.getItem('height') ? sessionStorage.getItem('height') : $('header').height();

        if (window.pageYOffset >= (height / 2) && window.pageYOffset < height) {
            body.addClass("before-stuck").removeClass("stuck").css('padding-top', '0');
        } else if (window.pageYOffset == 0) {
            body.removeClass("stuck").removeClass("before-stuck").css('padding-top', '0');
        } else if (window.pageYOffset > height) {
            body.addClass("stuck").removeClass("before-stuck").css('padding-top', height + 'px');

        }

    };


    // module.navDropdownHover = function () {
    //
    //     const $dropdown = $(".dropdown");
    //     const $dropdownToggle = $(".dropdown-toggle");
    //     const $dropdownMenu = $(".dropdown-menu");
    //     const showClass = "show";
    //
    //     $(window).on("load resize", function() {
    //         if (this.matchMedia("(min-width: 768px)").matches) {
    //             $dropdown.hover(
    //                 function() {
    //                     const $this = $(this);
    //                     $this.addClass(showClass);
    //                     $this.find($dropdownToggle).attr("aria-expanded", "true");
    //                     $this.find($dropdownMenu).addClass(showClass);
    //                 },
    //                 function() {
    //                     const $this = $(this);
    //                     $this.removeClass(showClass);
    //                     $this.find($dropdownToggle).attr("aria-expanded", "false");
    //                     $this.find($dropdownMenu).removeClass(showClass);
    //                 }
    //             );
    //         } else {
    //             $dropdown.off("mouseenter mouseleave");
    //         }
    //     });
    // };


    module.announcementBarDismiss = function () {
        if($('#announcement-dismiss').length) {
            $('#announcement-dismiss').click(function () {
                $.get("/announcement-dismiss", function () {
                    console.log("Announcement bar dismissed");
                    $('#announcement-dismiss').fadeOut(300);
                })
            });
        }
    };

    module.wrapResponsiveTables = function () {
        $('table').not('.table-responsive table, [class^="phpdebugbar"] table').wrap('<div class="table-responsive"></div>');
    };

    module.initSpotlightJs = function () {
        if ($('.spotlight').length)
            require('spotlight.js');
    };


    module.initTingleModalJs = function () {

        const Tingle = require('tingle.js');

        var modal = new Tingle.modal({
            stickyFooter: false,
            footer: false,
            closeMethods: ['overlay', 'button', 'escape'],
            cssClass: ['custom-class-1', 'custom-class-2'],
        });

        $('.md-trigger').click(function (event) {
            let id = $(this).data('id');
            modal.setContent($('#' + id).html());
            modal.open();
        });

        // ---- video modal ----

        var videoModal = new Tingle.modal({
            stickyFooter: false,
            footer: false,
            closeMethods: ['overlay', 'button', 'escape'],
            cssClass: ['tingle-video-modal'],
            onClose: function () {
                // clearing the content destroys the player, which stops the audio
                videoModal.setContent('');
            },
        });

        $(document).on('click', '.video-modal-trigger', function (event) {
            let $tpl = $('#' + $(this).data('id'));
            if (!$tpl.length) return; // no template, let the href do its thing

            event.preventDefault();
            event.stopPropagation();

            // slick fires a click at the end of a drag
            if ($(this).closest('.slick-slider').hasClass('is-dragging')) return;

            videoModal.setContent($tpl.html());

            let $content = $(videoModal.modalBoxContent);

            $content.find('[data-src]').each(function () {
                let src = $(this).data('src');
                if (this.tagName === 'IFRAME') {
                    src += (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
                }
                $(this).attr('src', src).removeAttr('data-src');
            });

            videoModal.open();

            let video = $content.find('video')[0];
            if (video) {
                video.play().catch(function () { /* autoplay blocked, controls are there */ });
            }
        });

        // pause the background slide videos while the modal is open
        // (optional - drop if you want them running underneath)
        $(document).on('tingle-video-open tingle-video-close', function () {});
    };

    module.initMobileMenu = function () {
        require('../plugins/jquery-simple-mobile-menu');
        $(".mobile_menu").simpleMobileMenu();
        $('#sm_menu_ham').addClass('icon').prependTo('.mobile-icons');
    };

    module.initSlickCarousel = function () {
        require('@accessible360/accessible-slick');

        $('.slick.testimonials').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            arrows: true,
            cssEase: 'linear',
        });

        $('.slick.shortcode-slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            fade: true,
            arrows: false,
            dots: true,
            cssEase: 'linear',
        });

        // A single hero slide doesn't need a carousel, and initialising one re-paints the hero image late
        $('.slick.slides').filter(function () {
            return $(this).children().length > 1;
        }).slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            arrows: false,
            dots: true,
            fade: true,
        });

        $('.carousel').slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2500,
            arrows: false,
            dots: false,
            infinite: true,
            speed: 600,
            cssEase: 'ease',
            responsive: [
                {breakpoint: 1200, settings: {slidesToShow: 5}},
                {breakpoint: 992, settings: {slidesToShow: 4}},
                {breakpoint: 768, settings: {slidesToShow: 3}},
                {breakpoint: 576, settings: {slidesToShow: 2}}
            ]
        });

        $('.cards-carousel').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            arrows: false,
            dots: true,
            speed: 500,
            cssEase: 'ease',
            responsive: [
                {breakpoint: 992, settings: {slidesToShow: 2}},
                {breakpoint: 576, settings: {slidesToShow: 1, dots: true, arrows: false}}
            ]
        });

        $('.tiles-carousel').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            arrows: false,
            dots: true,
            speed: 500,
            cssEase: 'ease',
            responsive: [
                {breakpoint: 992, settings: {slidesToShow: 2}},
                {breakpoint: 576, settings: {slidesToShow: 1, dots: true, arrows: false}}
            ]
        });


        $('.slick.gallery-slider').slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            variableWidth: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 0,
            speed: 18000,
            cssEase: 'linear',
            pauseOnHover: false,
            pauseOnFocus: false,
            draggable: false,
            swipe: false,
            touchMove: false,
            responsive: [
                {
                    breakpoint: 968,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });


        $('.image-carousel').slick({
            autoplay: true,
            autoplaySpeed: 4000,
            fade: true,
            speed: 900,
            cssEase: 'ease-in-out',
            arrows: false,
            dots: false,
            pauseOnHover: false,
            infinite: true
        });

        $('.gallery-slides').slick({
            slidesToShow: 2,
            autoplay: true,
            autoplaySpeed: 2500,
            cssEase: 'ease-in-out',
            arrows: false,
            dots: false,
            pauseOnHover: false,
            infinite: true
        });

        $('.projects-carousel').slick({
            dots:           true,
            appendDots:     '.js-dots',
            prevArrow: $('.js-prev'),
            nextArrow: $('.js-next'),
            arrows:         true,
            infinite:       true,
            speed:          400,
            slidesToShow:   3,
            slidesToScroll: 1,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });

        $('.card-slides').slick({
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            settings: 'unslick',
            responsive: [
                {
                    breakpoint: 768, // activates AT 768+ (mobileFirst adds 1)
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 991, // at 992+ destroy the slider
                    settings: 'unslick'
                }
            ]
        });

    };


        module.scrollToAnchor = function () {
        $('a[href^=\\#scroll-]').on('click', function (e) {
            e.preventDefault();

            let collapseId = $(this).attr('href').replace('scroll-', '');

            console.log(collapseId);

            module.scrollToElement(collapseId);
        });
    };


    module.detectUrlScrollHash = function () {
        if (window.location.hash.indexOf('scroll-') == 1) {

            let el = window.location.hash.replace('scroll-', '');

            console.log('Attempting automatic scroll to ' + el);

            this.scrollToElement(el);
        }
    };

    module.scrollToElement = function (element) {
        console.log('Attempt to scroll to el ' + element);
        $('html,body').animate({scrollTop: $(element).offset().top - 100}, 'slow', function () {
            if ($(element).length && $(element).next().hasClass('collapse')) {
                $(element).next().collapse('show');
            }
        });
    };

    module.scrollToAccordionItem = function () {

        $('.accordion').on('shown.bs.collapse', function (event) {
            let getHeaderEl = $('#' + event.target.id).prev('.card-header').attr('id');

            if (getHeaderEl)
                module.scrollToElement('#' + getHeaderEl);
        });

    };

    module.initWowJs = function () {
        const {WOW} = require('wowjs');
        new WOW({
            mobile: false,
        }).init();
    };


    module.convertCryptedEmails = function () {

        $('.cryptedmail').each(function () {

            let
                el = $(this).find('span'),
                e = el.data('name') + '@' + el.data('domain') + '.' + el.data('tld');

            $(this).attr('href', 'mailto:' + e).removeClass('cryptedmail').find('span');

            if ((typeof el.data('show-value') == 'undefined') || el.data('show-value'))
                el.html(el.data('value') ? el.data('value') : e);
        });
    };


    module.equalHeightInner = function () {
        function equalizeTextBlocks() {
            const blocks = document.querySelectorAll('.clipped-card > div:last-child');
            let maxHeight = 0;

            // Reset first
            blocks.forEach(el => el.style.minHeight = '');

            // Find tallest
            blocks.forEach(el => {
                if (el.offsetHeight > maxHeight) maxHeight = el.offsetHeight;
            });

            // Apply to all
            blocks.forEach(el => el.style.minHeight = maxHeight + 'px');
        }

        window.addEventListener('load', equalizeTextBlocks);
        window.addEventListener('resize', equalizeTextBlocks);
    }

    return module;

};
